import { useEffect, useState } from 'react';
import useEventsRecommended from '../useEventsRecommended';
import { getTodayUnix } from '@general/dates';
import useViewerEvents from '@hooks/useViewerEvents';

const useEventsRecommendedFilters = () => {
    const [filters, setFilters] = useState('objectID:NOT-AN-EVENT');
    const { recommendedEvents } = useEventsRecommended();
    const { data: viewerEvents } = useViewerEvents();

    useEffect(() => {
        if (!recommendedEvents || !viewerEvents) {
            return;
        }

        // created_at_timestamp represents the event start
        let filterBuilder = `created_at_timestamp >= ${getTodayUnix()} AND NOT event_types:"Committee Events"`;

        if (recommendedEvents.length > 0) {
            const eventFilters = recommendedEvents.map(eventCode => `event_code:${eventCode}`).join(' OR ');
            filterBuilder += ` AND (${eventFilters})`;
        }

        if (viewerEvents.length > 0) {
            const viewerEventFilters = viewerEvents
                .map(viewerEvent => `NOT event_code:${viewerEvent.code}`)
                .join(' AND ');

            filterBuilder += ` AND (${viewerEventFilters})`;
        }

        setFilters(filterBuilder);
    }, [recommendedEvents, viewerEvents]);

    return { filters };
};

export default useEventsRecommendedFilters;
